//@flow
import { useMediaQuery } from "@mui/material";
import React, { useEffect } from 'react';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import useMenuAction from "../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../hooks/menu/useMenuData";
import useConfig from "../../../../hooks/theme/useConfig";
import Logo from "../../../custom/general/logo/logo";
import LanguageSelect from "../../languageSelect/languageSelect";
import Drawer from "../drawer/drawer";
import Header from "../header/header";
import { useTheme } from "@mui/material/styles";

const MenuWithDrawer = (props) => {
	const theme = useTheme();
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	const { miniDrawer } = useConfig();
	const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));
	const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'))
	
	// set media wise responsive drawer
	useEffect(() => {
		if (!miniDrawer && drawerOpen) {
			setDrawerOpen(!matchDownLG)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [matchDownLG]);
	
	return (
		<Box>
			<Box sx={{ width: '100%', display: 'block', backgroundColor: 'white' }}>
				{/*<Header/>*/}
				{/*<Drawer/>*/}
				<Box mt={1} mb={1} sx={{ position: 'absolute', top: 0, right: '60px' }}>

				</Box>
				{/*<Logo*/}
				{/*	style={{*/}
				{/*		height: downSM*/}
				{/*			? "80px"       // μικρές οθόνες*/}
				{/*			: downMD*/}
				{/*				? "120px"      // μεσαίες οθόνες*/}
				{/*				: matchDownLG*/}
				{/*					? "170px"      // μεγάλες οθόνες αλλά κάτω από lg*/}
				{/*					: "200px",     // default πλήρης οθόνη*/}
				{/*		width: "auto",*/}
				{/*		maxWidth: "100%",*/}
				{/*	}}*/}
				{/*/>*/}
				
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						//p: 0.2,
						//pt: downSM ? 6 : 4,
						overflowX: 'auto'
					}}
				>
					{props.children}
				</Box>
			</Box>
		</Box>
	
	)
}

export default MenuWithDrawer;